import apiClient from './apiClient';
import { SocietyData } from '../../types/societyData';

export const getSocietyByName = async (name: string): Promise<SocietyData | null> => {
    try {
        const response = await apiClient.get('/societies', {
            params: { name }
        });

        const data = response.data.data[0];
        return data;
    } catch (error) {
        console.error('Error getting society by name:', error);
        return null;
    }
};

export const getSocietyById = async (id: string): Promise<SocietyData | null> => {
    try {
        const response = await apiClient.get('/societies', {
            params: { id }
        });
        const data = response.data.data[0];
        return data;
    } catch (error) {
        console.error('Error getting society by ID:', error);
        return null;
    }
};

export const getSocieties = async (): Promise<SocietyData[] | null> => {
    try {
        const response = await apiClient.get('/societies');

        const data = response.data.data;
        return data;
    } catch (error) {
        console.error('Error getting societies:', error);
        return null;
    }
};
